module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_0.b4e50460.png";